'use client';

import type { ButtonProps } from '@heroui/react';
import { Button as NextButton } from '@heroui/react';
const Button = ({
  children,
  className = '',
  ...rest
}: ButtonProps) => {
  const {
    variant,
    disabled
  } = rest;
  return <NextButton className={`${!variant ? disabled ? 'bg-gray-400' : 'bg-gradient-to-r from-primary-3 to-primary-2 text-white' : ''} ${className} ${variant === 'bordered' ? 'border-1.5' : ''}`} isDisabled={disabled} {...rest} data-sentry-element="NextButton" data-sentry-component="Button" data-sentry-source-file="index.tsx">
      {children}
    </NextButton>;
};
export default Button;